export enum DeviceRoutes {
    DeviceCreate = 'create',
    DeviceList = '',
    DeviceUpgrade = 'upgrade',
    FirmwareList = 'firmware/list'
}
